const countries = [
  {
    name: 'India',
    flag: 'IN',
    code: '+91',
  },
  {
    name: 'China',
    flag: 'CN',
    code: '+86',
  },
  {
    name: 'Thailand',
    flag: 'TH',
    code: '+66',
  },
  {
    name: 'Germany',
    flag: 'DE',
    code: '+49',
  },
  {
    name: 'Philippines',
    flag: 'PH',
    code: '+63',
  },
  {
    name: 'Vietnam',
    flag: 'VN',
    code: '+84',
  },
  {
    name: 'Myanmar',
    flag: 'MM',
    code: '+95',
  },
  {
    name: 'Ghana',
    flag: 'GH',
    code: '+233',
  },
  {
    name: 'Tanzania',
    flag: 'TZ',
    code: '+255',
  },
  {
    name: 'Nigeria',
    flag: 'NG',
    code: '+234',
  },
  {
    name: 'Egypt',
    flag: 'EG',
    code: '+20',
  },
  {
    name: 'Angola',
    flag: 'AO',
    code: '+244',
  },
];

export default countries;
export { countries };
